module.exports = __webpack_public_path__ + "img/public/SiteIcons/priceIconNew.svg?62e09d29";